function injectStyle (ssrContext) {
  require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0588d2c2\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?sourceMap!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./unsubscribed.vue")
}
var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./unsubscribed.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0588d2c2\",\"hasScoped\":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./unsubscribed.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0588d2c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/unsubscribed/unsubscribed.vue
// module id = 2765
// module chunks = 1